export default __webpack_public_path__ + "static/media/products.ba934dd7.jpeg";